import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/components/entities/header/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/components/ui/container/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/components/ui/title/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/views/success-story/components/success-list/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/views/success-story/index.module.scss");
